/* Maison Héloïse — theme.js
   Mega menu, navigation mobile, carousel hero, accordéon FAQ.
   Vanilla JS, aucune dépendance. */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Mega menu ---------- */

  function initHeader(header) {
    var trigger = header.querySelector('[data-mega-trigger]');
    var mega = header.querySelector('[data-mega]');
    if (!trigger || !mega) return;

    function open() {
      mega.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      mega.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    header.addEventListener('mouseleave', close);

    header.querySelectorAll('[data-mega-close]').forEach(function (el) {
      el.addEventListener('mouseenter', close);
    });
    var cartBtn = header.querySelector('[data-cart-toggle]');
    if (cartBtn) cartBtn.addEventListener('mouseenter', close);
    var logo = header.querySelector('.mh-header__logo');
    if (logo) logo.addEventListener('mouseenter', close);

    mega.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !mega.hidden) {
        close();
        trigger.focus();
      }
    });
    document.addEventListener('focusin', function (event) {
      if (!mega.hidden && !header.contains(event.target)) close();
    });
  }

  /* ---------- Navigation mobile ---------- */

  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    var openBtn = document.querySelector('[data-nav-open]');
    if (!nav || !openBtn) return;
    var closeBtn = nav.querySelector('[data-nav-close]');

    function open() {
      nav.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      nav.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !nav.hidden) close();
    });
  }

  /* ---------- Carousel hero ---------- */

  function initHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;
    var counter = hero.querySelector('[data-hero-counter]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var autoplayMs = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    var index = 0;
    var timer = null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      if (counter) counter.textContent = pad(index + 1) + ' / ' + pad(slides.length);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (autoplayMs > 0 && slides.length > 1 && !reducedMotion.matches && !document.hidden) {
        timer = setInterval(function () {
          goTo(index + 1);
        }, autoplayMs);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
        start();
      });
    }

    document.addEventListener('visibilitychange', start);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', start);

    goTo(0);
    start();
  }

  /* ---------- FAQ (un seul item ouvert) ---------- */

  function initFaq(faq) {
    var toggles = faq.querySelectorAll('[data-faq-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggles.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
          var otherGlyph = other.querySelector('[data-faq-glyph]');
          if (otherGlyph) otherGlyph.textContent = '+';
        });
        if (!expanded) {
          toggle.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(toggle.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
          var glyph = toggle.querySelector('[data-faq-glyph]');
          if (glyph) glyph.textContent = '−';
        }
      });
    });
  }

  /* ---------- Recommandations produit ---------- */

  function initRelated(container) {
    var url = container.getAttribute('data-url');
    if (!url || container.hasAttribute('data-related-loaded')) return;
    container.setAttribute('data-related-loaded', '');
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (fresh && fresh.querySelector('.mh-card')) {
          container.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {
        /* le repli rendu côté serveur reste affiché */
      });
  }

  /* ---------- Tri collection ---------- */

  function initSort() {
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-header]').forEach(initHeader);
    (root || document).querySelectorAll('[data-hero]').forEach(initHero);
    (root || document).querySelectorAll('[data-faq]').forEach(initFaq);
    (root || document).querySelectorAll('[data-related]').forEach(initRelated);
    initMobileNav();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Ré-initialisation dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
